'use client';

import { useMousePosition } from "@/frontend/hooks/useMousePosition";
import { useState } from "react";
import './styles.scss';
import { AnimatePresence, motion } from "motion/react";
import { useMediaQuery } from "@/frontend/hooks/useMediaQuery";
import { useElementEvent } from "@/frontend/hooks/useDocumentEvent";
import Image from "next/image";

export const MouseImageFollow = ({ containerReference }: MouseFollowTypes) => {
  const mousePos = useMousePosition();
  const [target, setTarget] = useState<string>('');
  const mediaQuery = useMediaQuery('(min-width: 1023px)');

  useElementEvent(containerReference, 'mouseenter mouseleave', (event) => {
    if (event.type === 'mouseenter') return setTarget('container');
    return setTarget('');
  });

  return (
    <AnimatePresence>
      {(target === 'container' && mediaQuery) && <ImageElement left={mousePos.clientX || 0} top={mousePos.clientY || 0} />}
    </AnimatePresence>
  );
};
MouseImageFollow.displayName = 'MouseImageFollow';

const ImageElement = ({ left, top }: MouseFollowElementTypes) => {
  return (
    <motion.div
      className="mouse-follow-element image-follow"
      style={{ x: left, y: top }}
      exit={{ scale: 0 }}
      initial={{ scale: 0, }}
      animate={{ scale: 1 }}
    >
      <Image unoptimized={true} src="/frontend/sorry.gif" width={300} height={300} alt="" />
    </motion.div>
  )
};
ImageElement.displayName = 'ImageElement';

//
// Types
// -----------------------------------------------------------------------------

interface MouseFollowTypes {
  containerReference: string;
};

interface MouseFollowElementTypes {
  left: number;
  top: number;
};